module.exports = __webpack_public_path__ + "img/title4.0539b127.png";